export default __webpack_public_path__ + "static/media/steps-ball-grey.2a7454c8.svg";